import "./StyleSelectionGroup.css";
import React from "react";

const StyleSelectionGroup = React.memo(
  ({ styleOptions, selectedStyle, handleStyleSelection }) => {
    return (
      <div className="ButtonGroup__container">
        {styleOptions.map((style, index) => (
          <button
            key={`${style.code} - ${index}`}
            className={`ButtonGroup__button ${selectedStyle === style.code ? "active" : ""}`}
            onClick={() => handleStyleSelection(style.code)}
          >
            {style.name}
          </button>
        ))}
      </div>
    );
  }
);

export default StyleSelectionGroup;
